import(/* webpackMode: "eager" */ "/vercel/path0/client/src/app/global-error.js");
